import { render, staticRenderFns } from "./RedactorMenu.vue?vue&type=template&id=06e46863&"
import script from "./RedactorMenu.vue?vue&type=script&lang=js&"
export * from "./RedactorMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports